package com.rikonardo.pluginscan.framework.internal

import com.rikonardo.pluginscan.framework.types.Check

// This check should not be registered
class ParsingFailedCheck: Check()